import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Card from '../components/Card';
import Fuse from 'fuse.js';
import { useNavigate } from 'react-router-dom';

const Pokemon = () => {
    const [data, setData] = useState([]);
    const [rangeValue, setRangeValue] = useState(36);
    const [searchValue, setSearchValue] = useState("");
    const [selectedGeneration, setSelectedGeneration] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageGroup, setPageGroup] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('https://tyradex.vercel.app/api/v1/pokemon').then((res) => {
            const filteredData = res.data.slice(1);
            setData(filteredData);
        });
    }, []);

    const fuse = new Fuse(data, {
        keys: ['name.fr'],
        includeScore: true
    });

    const filteredData = searchValue ? fuse.search(searchValue).map(result => result.item) : data;

    const exactMatch = data.find(pokemon => pokemon.name.fr.toLowerCase() === searchValue.toLowerCase());

    const handleRandomPokemon = () => {
        const randomId = Math.floor(Math.random() * 1000) + 1;
        navigate(`/pokemon/${randomId}`);
    };

    const handleSelectGeneration = (event) => {
        setSelectedGeneration(event.target.value);
    };

    const filteredByGeneration = selectedGeneration !== "all"
        ? filteredData.filter(pokemon => pokemon.generation === parseInt(selectedGeneration))
        : filteredData;

    const totalPages = Math.ceil(filteredByGeneration.length / rangeValue);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePreviousPageGroup = () => {
        if (pageGroup > 0) {
            setPageGroup(pageGroup - 1);
            setCurrentPage(pageGroup * 3);
        }
    };

    const handleNextPageGroup = () => {
        if ((pageGroup + 1) * 3 < totalPages) {
            setPageGroup(pageGroup + 1);
            setCurrentPage((pageGroup + 1) * 3 + 1);
        }
    };

    const paginatedData = filteredByGeneration.slice((currentPage - 1) * rangeValue, currentPage * rangeValue);

    return (
        <div className="pokemon">
            <ul className="radio-container">
<input
    type="range"
    min="1"
    max="1025"
    value={rangeValue}
    onChange={(e) => setRangeValue(e.target.value)}
/>
<span>{rangeValue} Pokémon par page</span>

                <input
                    type="text"
                    placeholder="Rechercher par nom de Pokémon"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
                <button onClick={handleRandomPokemon}>Pokémon Aléatoire</button>
                <select value={selectedGeneration} onChange={handleSelectGeneration}>
                    <option value="all">Toutes les générations</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(gen => (
                        <option key={gen} value={gen}>Génération {gen}</option>
                    ))}
                </select>
            </ul>
            <ul>
                {exactMatch ? (
                    <Card key={exactMatch.id} pokemon={exactMatch} />
                ) : (
                    paginatedData.map((pokemon, index) => (
                        <Card key={index} pokemon={pokemon} />
                    ))
                )}
            </ul>
            <div className="pagination">
                <button onClick={handlePreviousPageGroup} disabled={pageGroup === 0}>
                    &laquo; Précédent
                </button>
                {Array.from({ length: Math.min(3, totalPages - pageGroup * 3) }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handlePageChange(pageGroup * 3 + index + 1)}
                        className={`pagination-button ${currentPage === pageGroup * 3 + index + 1 ? 'active' : ''}`}
                    >
                        {pageGroup * 3 + index + 1}
                    </button>
                ))}
                <button onClick={handleNextPageGroup} disabled={(pageGroup + 1) * 3 >= totalPages}>
                    Suivant &raquo;
                </button>
            </div>
        </div>
    );
};

export default Pokemon;

